export default "__VITE_ASSET__CEjGshEQ__"